import { DesktopView } from './components/DesktopView';
import { MobileView } from './components/MobileView';
import { SeoHeaderLinks } from './components/SeoHeaderLinks';

export const MarcomAppNavBar = {
  Mobile: MobileView,
  Desktop: DesktopView,
  SeoHeaderLinks: SeoHeaderLinks
};

export { useMarcomAppNavBar } from './useMarcomAppNavBar';
